var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79376 6.12203C2.40208 6.50218 2.40208 7.11509 2.79376 7.49524L9.43645 13.9423C9.7482 14.2449 10.2518 14.2449 10.5635 13.9423L17.2062 7.49524C17.5979 7.11509 17.5979 6.50218 17.2062 6.12203C16.8145 5.74188 16.1831 5.74188 15.7914 6.12203L9.996 11.739L4.20064 6.11427C3.81695 5.74188 3.17746 5.74188 2.79376 6.12203Z",
    fill: "#555893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.136788d2.svg";
export { ForwardRef as ReactComponent };